import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../style.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeItem, setActiveItem] = useState('Home');

  const menuItems = [
    { name: 'Home', type: 'route', path: '/' },
    { name: 'About Us', type: 'route', path: '/about' },
    { name: 'Tour Package', type: 'route', path: '/tour-packagesection' },
    { name: 'Air Ticket', type: 'route', path: 'texi-services' },
    { name: 'Hotel Booking', type: 'route', path: '/hotel-booking' },
    { name: 'Cab Service', type: 'route', path: '/texi-services' },
    { name: 'Pind Daan', type: 'route', path: '/pind-daan' },
    { name: 'Book Cruise', type: 'route', path: 'book-cruise' },
    { name: 'Contact', type: 'route', path: 'contact' }
  ];

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleItemClick = (item) => {
    setActiveItem(item.name);
    setIsOpen(false);
    
    // Anchor links के लिए scroll करें
    if (item.type === 'anchor') {
      const element = document.getElementById(item.id);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Left Side - Logo */}
        <div className="navbar-logo">
          <Link to="/">
            <img 
              src="/logo.png" 
              alt="Shree Balaji Travels Logo" 
              className="logo-image"
            />
          </Link>
          <div className="logo-text">
            <h1 className="company-name">Shree Balaji Travels</h1>
          </div>
        </div>

        {/* Hamburger Menu */}
        <button 
          className={`hamburger-menu ${isOpen ? 'open' : ''}`} 
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Right Side - Menu Items */}
        <ul className={`navbar-menu ${isOpen ? 'active' : ''}`}>
          {menuItems.map((item) => (
            <li 
              key={item.name} 
              className={`navbar-item ${activeItem === item.name ? 'active' : ''}`}
              onClick={() => handleItemClick(item)}
            >
              {item.type === 'route' ? (
                // Route links (Home, About Us)
                <Link to={item.path}>
                  {item.name}
                </Link>
              ) : (
                // Anchor links (बाकी सब)
                <a href={`#${item.id}`} onClick={(e) => e.preventDefault()}>
                  {item.name}
                </a>
              )}
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;